<template>
  <router-view />
</template>

<style lang="scss">
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~material-design-icons-iconfont/dist/material-design-icons.css";

@import "./assets/sass/style.scss";
@import "./assets/sass/_variables.scss";
@import "./assets/sass/common.scss";

// Check documentation for RTL css
// Update HTML with RTL attribute at public/index.html
/*@import "assets/css/style.vue.rtl";*/
@import "./custom.css";
$material-design-icons-font-directory-path: '~material-design-icons-iconfont/dist/fonts/';
@import '~material-design-icons-iconfont/src/material-design-icons';

// 2026 redesign — global theme layer (must be last so it wins the cascade)
@import "./assets/sass/theme.scss";
</style>

<script>
export default {
  name: "Kema-Admin-Panel",
};
</script>
